import request from '@/libs/request';
import config from '@/config';

/**
 * 获取用户信息
 * 也是初始接口
 * 每次F5刷新都必须先调用它
 * @param {*} data
 */
export const UserInfo = data => {
  return request('post', `${config.api_base}/api/unauth/info`, data);
};

/**
 * 获取国家地区列表
 * @param {*} data
 * @returns
 */
export const AreaListAll = data => {
  return request('get', `${config.api_base}/api/auth/sys/dict/region/all`, data);
};

/**
 * 根据父级获取国家地区列表
 * @param {*} data
 * @returns
 */
export const AreaListByParent = data => {
  return request('get', `${config.api_base}/api/auth/sys/dict/region/parent`, data);
};

/**
 * 获取Aliyun OSS STS临时授权(登录)
 */
export const getAliyunOSSConfigRead = data => {
  return request('get', `${config.api_base}/api/auth/sys/system/oss/sts/read`, data);
};

export const getAliyunOSSConfigWrite = data => {
  return request('get', `${config.api_base}/api/auth/sys/system/oss/sts/write`, data);
};

/**
 * 获取Aliyun OSS STS临时授权(未登录)
 */
export const getAliyunOSSConfigUnauthRead = data => {
  return request('get', `${config.api_base}/api/unauth/oss/sts/read`, data);
};

export const getAliyunOSSConfigUnauthWrite = data => {
  return request('get', `${config.api_base}/api/unauth/oss/sts/write`, data);
};
